const fr = {
  nav: {
    home: "Accueil",
    finances: "Finances",
    foyer: "Mon Foyer",
    market: "Market",
    pots: "Cagnottes",
    friends: "Proches & amis",
    account: "Compte en ligne + carte",
    assistant: "Assistant IA",
    settings: "Réglages",
    brand: "Identité visuelle",
    pro: "Espace Pro",
    admin: "Administration",
  },
  roles: { owner: "Propriétaire", admin: "Administrateur", adult: "Adulte", child: "Enfant", guest: "Invité" },
  orgTypes: { repairer: "Réparateur", installer: "Installateur", manufacturer: "Fabricant", insurer: "Assureur", bank: "Banque" },
  platformRoles: { admin: "Administrateur CASHMY", demo_admin: "Super admin démo (lecture seule)", support_viewer: "Console en lecture seule" },
};

const dictionaries = { fr };
let current = "fr";

export const setLanguage = (lang) => { if (dictionaries[lang]) current = lang; };
export const t = (key) => key.split(".").reduce((o, k) => o?.[k], dictionaries[current]) ?? key;
